import React from 'react';
import $ from 'jquery';
import { Container, ImageScroller } from '../components.js';

/* REQUIRED PROPS
 * @param req type string : the rec type for this container 
 * @param req title string : title for the container box
 * @param opt size {width, height} object: for size of container
 * @param opt addClass string : more cSS class fro the  moreClass for container
*/

class RecContainer extends React.Component {
	constructor(props) {
		super(props);

		this.exportRecs = this.exportRecs.bind(this);
	}

	exportRecs(e) {
		var recs = window._fiSponsor.sponsors[0].recommendations[this.props.type].data;

		if(recs.length  ===  0) {
			alert('We don\'t have any recommendations for you just yet in this category!\n\nContact support@plinqit.com with any questions');
			return;
		}

		if (this.props.type === 'credit') {
			let credit_key_array = ['visa','mastercard','discover','american express', 'amex', 'capital one', 'capitalone','chase', 'pnc', 'bank of america'];
			for(var r in recs) {
				var rec = recs[r];
				var credit_cards = [];

				for(var k in credit_key_array) {
					var key = credit_key_array[k];

					if(rec.tags.toLowerCase().indexOf(key) > -1) {
						credit_cards.push(key);
					}
				}

				credit_cards = credit_cards.join();

				recs[r]['Cards Used'] = credit_cards;
			}
		}

		//Export as CSV Variant
		var csvContent = '';

		var keys = Object.keys(recs[0]);

		keys.splice(keys.indexOf('tags'), 1);

		keys.splice(keys.indexOf('image_urls'))

		csvContent += keys.join(',');

		csvContent += '\r\n';

		for(var key in recs) {
			var rec = recs[key];

			for(var rKey in rec) {
				if(rec[rKey] === null || typeof rec[rKey] === 'undefined') continue;
				var newVals = rec[rKey].replace(/[,]/g, "; ");
				rec[rKey] = newVals;
			}

			var values = Object.values(rec),
				rKeys = Object.keys(rec);

			values.splice(rKeys.indexOf('tags'), 1);
			rKeys.splice(rKeys.indexOf('tags'), 1);
			values.splice(rKeys.indexOf('image_urls'), 1);

			var valueAdd = values.join(',');
			valueAdd = valueAdd.replace(/[\r\n]/g, '');

			csvContent += valueAdd + '\r\n';
		}

		var fileName = window._fiSponsor.sponsors[0].name.replace(/[/\\?%*: |"<>]/g, '-');
		fileName += "-" + this.props.type + "-Recommendations.csv"

		var blob = new Blob(["\ufeff", csvContent]);
		var url = URL.createObjectURL(blob);
		var link = document.createElement("a");
		link.href = url;
		link.download = fileName;
		document.body.appendChild(link); // Required for FF

		link.click(); 
		link.remove();

	}

	render() {
		const recContainerSize = {
			width: (this.props.size) ? this.props.size.width : '40vmin',
			height: (this.props.size) ? this.props.size.height : 'auto'
		};

		var recContent = (<div className='RecContainer'>No recommendations yet</div>);

		if(window._fiSponsor.sponsors[0].recommendations.hasOwnProperty(this.props.type)) {

			var imagePromptText = 'These users have shown interest in ' + this.props.type,
				images = window._fiSponsor.sponsors[0].recommendations[this.props.type].bank_images;

			switch(this.props.type) {
				case 'credit':
					imagePromptText = 'Your Plinqit users are making payments to these credit card companies.';
					var data = window._fiSponsor.sponsors[0].recommendations[this.props.type].data,
						ccImgs = { 
							'visa' : process.env.PUBLIC_URL + "images/visa.png",
							'mastercard' : process.env.PUBLIC_URL + "images/mastercard.png",
							'discover' : process.env.PUBLIC_URL + "images/discover.png",
							'american express' : process.env.PUBLIC_URL + "images/amex.png",
							'capital one' : process.env.PUBLIC_URL + "images/capitalone.png",
							'capitalone' : process.env.PUBLIC_URL + "images/capitalone.png"
							};

					for(var key in data) {
						var datum = data[key];
						for(var cKey in ccImgs) {
							if(datum.tags.toLowerCase().indexOf(cKey) > -1 && images.indexOf(ccImgs[cKey]) === -1) {
								images.push(ccImgs[cKey]);
							}
						}
					}
					break;
				case 'checking':
					imagePromptText = 'These users have linked a checking account to Plinqit from a different financial institution.';
					break;
				case 'mortgage':
					imagePromptText = 'These Plinqit users have shown interest in purchasing a home.';
					break;
				default:
					break;
			}

		  	recContent = (
		  		<div className='RecContainer'>
		  			<div className='Images-Prompt'>
		  				{imagePromptText}
		  			</div>
		  			<ImageScroller
		  				images={window._fiSponsor.sponsors[0].recommendations[this.props.type].bank_images}
		  				display_limit={3}
		  			/>
		  			<div className='Divider'></div>
		  			<div className='Download-Prompt'>
		  				Download the list of Plinqit users who may be a target for this product.
		  			</div>
		  			<div className='Export-Div'>
		  				Export list
		  				<div className='Export-Button' onClick={this.exportRecs}>Download</div>
		  			</div>
		  		</div>
		  		);
	  	} 



  		return (
      		<Container 
      			key={this.props.type + 'recContainer'} 
      			moreClass={"Container-Stackable " + this.props.addClass} 
      			titles={[{'label' : this.props.title, 'onClick' : ''}]} 
      			contents={recContent} 
      			size={recContainerSize} 
      			bgcolor="rgb(100, 160, 67)" 
      		/>
  		);
	}
}

export default RecContainer;